import type { useContentViewsDetailsPanelContentViewsQuery } from '../hooks/__types__/useContentViewsDetailsPanelContentViewsQuery';
import { SitePermissionType } from '../hooks/__types__/useContentViewsDetailsPanelContentViewsQuery';

export const normalizeContentViewsData = (data?: useContentViewsDetailsPanelContentViewsQuery) => {
	const contentAnalyticsViewers = data?.contentAnalyticsViewers;
	const user = data?.user;

	return {
		count: contentAnalyticsViewers?.count,
		isInternalUser: user?.confluence?.permissionType === SitePermissionType.INTERNAL,
		isSSRError: contentAnalyticsViewers === null,
	};
};
